import { useContext } from "react";
import { observer } from "mobx-react-lite";
import { Button } from "@blueprintjs/core";
import { faMinusCircle } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { PatternEditor } from "@components";

import { WorkbenchContext } from "@pages/editor/providers";

import { PatternSelect } from "./PatternSelect";

const FixRowComponent: React.FC = () => {
  const { workbench } = useContext(WorkbenchContext);
  const { bundle } = workbench;

  if (bundle === null || bundle.simpleRule === undefined) {
    // Should never get here because you can't switch to Simple Mode
    return null;
  }

  const onChangeFix = (newPattern: string) => {
    bundle.onSimpleRuleChange({ ...bundle.simpleRule!, fix: newPattern });
  };

  const onRemoveFix = () => {
    bundle.onSimpleRuleChange({ ...bundle.simpleRule!, fix: "" });
  };

  return (
    <>
      <div style={{ gridColumnStart: 1 }}>
        <PatternSelect
          value={"pattern-fix"}
          // no onChange because you can't change from autofix
          onChange={(_) => {}}
          disabled={true}
        />
      </div>
      <PatternEditor
        pattern={bundle.simpleRule.fix}
        onPatternChange={onChangeFix}
        language={bundle.language!}
        keyComboRunAction={bundle.run}
      />
      <Button
        minimal
        small
        intent="primary"
        onClick={onRemoveFix}
        style={{ gridColumnStart: 3 }}
      >
        <FontAwesomeIcon
          icon={faMinusCircle}
          color={"var(--global-warning-color)"}
          size="lg"
        />
      </Button>
    </>
  );
};

export const FixRow = observer(FixRowComponent);
